import React from "react"
import { Link } from "gatsby"
import { getRelatedPlatforms } from "../data/platforms"

const RelatedPlatforms = ({ currentSlug }) => {
  const relatedPlatforms = getRelatedPlatforms(currentSlug)

  if (relatedPlatforms.length === 0) {
    return null
  }

  return (
    <section className="related-platforms">
      <h2>Related platform guides</h2>
      <ul>
        {relatedPlatforms.map(platform => (
          <li key={platform.slug}>
            <Link to={`/add-product-feed/${platform.slug}/`}>
              {platform.name}
            </Link>
            {" — "}
            {platform.desc}
          </li>
        ))}
      </ul>
      <p>
        <Link to="/getting-started/#platforms">View all platforms</Link>
      </p>
    </section>
  )
}

export default RelatedPlatforms
